import { apiClient } from '@/services/Axios';
import { v1Delete, v1Get, v1Patch, v1Post } from '@/services/v1Api';

function dmxBase(projectId) {
    return `/api/v1/projects/${projectId}/dmx-patch`;
}

export async function getDmxFixtures(projectId, params = {}) {
    const { data } = await v1Get(`${dmxBase(projectId)}/fixtures`, params);
    return { success: true, data };
}

export async function createDmxFixture(projectId, payload) {
    const { data } = await v1Post(`${dmxBase(projectId)}/fixtures`, payload);
    return { success: true, data };
}

export async function updateDmxFixture(projectId, fixtureId, payload) {
    const { data } = await v1Patch(`${dmxBase(projectId)}/fixtures/${fixtureId}`, payload);
    return { success: true, data };
}

export async function deleteDmxFixture(projectId, fixtureId) {
    await v1Delete(`${dmxBase(projectId)}/fixtures/${fixtureId}`);
}

export async function bulkDeleteDmxFixtures(projectId, payload) {
    await apiClient.delete(`${dmxBase(projectId)}/fixtures/bulk-delete`, { data: payload });
}

export async function bulkRepatchDmxFixtures(projectId, payload) {
    const { data } = await v1Patch(`${dmxBase(projectId)}/fixtures/bulk-repatch`, payload);
    return { success: true, data };
}

export async function getDmxFilterOptions(projectId) {
    const { data } = await v1Get(`${dmxBase(projectId)}/filter-options`);
    return { success: true, data };
}

export async function getDmxSheets(projectId) {
    const { data } = await v1Get(`${dmxBase(projectId)}/sheets`);
    return { success: true, data };
}

export async function createDmxSheet(projectId, payload) {
    const { data } = await v1Post(`${dmxBase(projectId)}/sheets`, payload);
    return { success: true, data };
}

export async function updateDmxSheet(projectId, sheetId, payload) {
    const { data } = await v1Patch(`${dmxBase(projectId)}/sheets/${sheetId}`, payload);
    return { success: true, data };
}

export async function deleteDmxSheet(projectId, sheetId) {
    await v1Delete(`${dmxBase(projectId)}/sheets/${sheetId}`);
}

export async function getDmxPositions(projectId) {
    const { data } = await v1Get(`${dmxBase(projectId)}/positions`);
    return { success: true, data };
}

export async function createDmxPosition(projectId, payload) {
    const { data } = await v1Post(`${dmxBase(projectId)}/positions`, payload);
    return { success: true, data };
}

export async function getFixtureLibraryManufacturers() {
    const { data } = await v1Get('/api/v1/fixture-library/manufacturers');
    return { success: true, data };
}

export async function getFixtureLibraryModels(manufacturerId) {
    const { data } = await v1Get(`/api/v1/fixture-library/manufacturers/${manufacturerId}/models`);
    return { success: true, data };
}

export async function getFixtureLibraryModes(fixtureLibraryId) {
    const { data } = await v1Get(`/api/v1/fixture-library/models/${fixtureLibraryId}/modes`);
    return { success: true, data };
}
